export default {
  title: 'ไทม์ชีท',
  description: 'ติดตามและจัดการชั่วโมงทำงาน',
  week_of: 'สัปดาห์ที่ {{date}}',
  previous_week: 'สัปดาห์ก่อน',
  next_week: 'สัปดาห์ถัดไป',
  this_week: 'สัปดาห์นี้',
  total_hours: 'ชั่วโมงรวม',
  daily_total: 'รวมรายวัน',
  weekly_total: 'รวมรายสัปดาห์',
  clock_in: 'เวลาเข้า',
  clock_out: 'เวลาออก',
  hours: 'ชั่วโมง',
  notes: 'หมายเหตุ',
  add_entry: 'เพิ่มรายการ',
  edit_entry: 'แก้ไขรายการ',
  view_entry: 'ดูรายการ',
  not_clocked_out: 'ยังไม่เลิกงาน',
  no_selfie: 'ไม่มีเซลฟี่',
  no_location: 'ไม่มีตำแหน่ง',
  delete_entry: 'ลบรายการ',
  lock_week: 'ล็อคสัปดาห์',
  unlock_week: 'ปลดล็อคสัปดาห์',
  locked_by: 'ล็อคโดย {{name}} เมื่อ {{date}}',
  week_locked: 'สัปดาห์นี้ถูกล็อคแล้ว',
  staff_member: 'พนักงาน',
  all_staff: 'พนักงานทั้งหมด',
  // EP-154: a shift clocked in from the dashboard, and its proofs.
  in_progress: 'กำลังทำงาน',
  location: 'ตำแหน่ง',
  attachments: 'ไฟล์แนบ',
  attachments_hint: 'อัปโหลดรูปภาพหรือใบเสร็จ (สูงสุด 5 ไฟล์)',
  no_entries: 'ไม่มีรายการในสัปดาห์นี้',
  setup_guide: 'กดปุ่ม + ที่วันใดก็ได้เพื่อบันทึกชั่วโมงทำงาน สามารถเพิ่มได้หลายรายการต่อวัน',
  guide_step_1: 'กดปุ่ม + ที่วันที่ต้องการ',
  guide_step_2: 'ระบุเวลาเข้า/ออก หรือชั่วโมง',
  guide_step_3: 'แนบรูปภาพถ้าต้องการ',
  confirm_delete: 'ลบรายการไทม์ชีทนี้หรือไม่?',
  confirm_lock: 'ล็อคสัปดาห์นี้หรือไม่? พนักงานจะไม่สามารถแก้ไขรายการได้',
  confirm_unlock: 'ปลดล็อคสัปดาห์นี้หรือไม่? พนักงานจะสามารถแก้ไขรายการได้อีกครั้ง',
  // EP-141 T141-002 — moved from visitors:calendar.* (see en/timesheet.ts for
  // which keys were dropped instead of moved, and why).
  // T141-017 — "กะ" (shift) replaced with "รายการ" (entry, matching
  // add_entry/edit_entry/delete_entry above) throughout: the owner-chosen
  // vocabulary is "Entry", not "Shift", and schedule_label's EN side never
  // said "shift" in the first place, so "ตารางกะ" was already a mismatch.
  schedule_label: 'ตารางเวลา',
  hours_label: 'ชั่วโมง',
  // T141-011
  add_entry_for: 'เพิ่มรายการให้ {{name}}',
  legend_entry: 'รายการ',
  legend_visit: 'การเยี่ยมชม',
  // T141-010 — staff/accountant self-lock.
  lock_my_week: 'ล็อคสัปดาห์ของฉัน',
  confirm_self_lock: 'ล็อคสัปดาห์ของคุณหรือไม่? หลังจากนี้คุณจะไม่สามารถแก้ไขรายการในสัปดาห์นี้ได้ และต้องให้ผู้ดูแลระบบหรือเจ้าของบัญชีเป็นผู้ปลดล็อคเท่านั้น',
  // T141-016
  locked_week_notice: 'สัปดาห์นี้ถูกล็อคแล้ว ในฐานะผู้ดูแลระบบหรือเจ้าของบัญชี คุณยังสามารถบันทึกรายการนี้ได้',
  messages: {
    entry_created: 'สร้างรายการเรียบร้อยแล้ว',
    entry_updated: 'อัปเดตรายการเรียบร้อยแล้ว',
    entry_deleted: 'ลบรายการเรียบร้อยแล้ว',
    week_locked: 'ล็อคสัปดาห์เรียบร้อยแล้ว',
    week_unlocked: 'ปลดล็อคสัปดาห์เรียบร้อยแล้ว',
  },
  errors: {
    week_not_ended: 'ล็อคได้เมื่อสัปดาห์นั้นผ่านไปแล้ว',
    open_shift_in_week: 'ยังมีกะที่เปิดอยู่ในสัปดาห์นี้ ปิดกะนั้นก่อน',
  },
  days: {
    mon: 'จ.',
    tue: 'อ.',
    wed: 'พ.',
    thu: 'พฤ.',
    fri: 'ศ.',
    sat: 'ส.',
    sun: 'อา.',
  },
}
